<template>
    <div class="office-container">
        <connection @change="connectionChanged" />
        <aside
            class="sidebar"
            :class="{'sidebar-hidden' : sidebarHidden}"
        >
            <div class="sidebar-top">
                <img
                    src="/img/logos/black_white.png"
                    alt="SwiftWork"
                    class="office-logo"
                    v-if="!sidebarHidden"
                >
                <img
                    src="/img/logos/launch-icon-dark.png"
                    alt="SwiftWork"
                    class="office-logo-small"
                    v-if="sidebarHidden"
                >
            </div>
            <nav>
                <ul>
                    <li>
                        <router-link
                            to="/office/"
                            exact
                        >
                            <i class="fa fa-tachometer-alt" />
                            <span class="nav-text"> Dashboard</span>
                        </router-link>
                    </li>
                </ul>
                <span class="nav-title">Customers</span>
                <ul>
                    <li title="Search Customer">
                        <router-link
                            to="/office/customers/"
                            exact
                        >
                            <i class="fa fa-building" />
                            <span class="nav-text"> Search Customers
                                <span class="badge badge-pill badge-primary">{{ customers_count }}</span>
                            </span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/customers/new"
                            exact
                        >
                            <i class="fa fa-plus" />
                            <span class="nav-text"> New Customer</span>
                        </router-link>
                    </li>
                    <li title="Service Reminders">
                        <router-link
                            to="/office/service-reminders"
                            exact
                        >
                            <i class="fa fa-calendar-check" />
                            <span class="nav-text"> Service Reminders</span>
                        </router-link>
                    </li>
                </ul>
                <span class="nav-title">Jobs</span>
                <ul>
                    <li>
                        <router-link
                            to="/office/jobs/schedule"
                            exact
                        >
                            <i class="fa fa-calendar-alt" />
                            <span class="nav-text"> Jobs Schedule
                                <span class="badge badge-pill badge-success">{{ jobs_count }}</span>
                            </span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/jobs/"
                            exact
                        >
                            <i class="fa fa-briefcase" />
                            <span class="nav-text"> Jobs List</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/jobs/call-outs"
                            exact
                        >
                            <i class="fa fa-phone" />
                            <span class="nav-text"> Call Out Jobs</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/invoiceable-forms/"
                            exact
                        >
                            <i class="fa fa-pound-sign" />
                            <span class="nav-text"> Invoiceable Forms</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/forms/"
                            exact
                        >
                            <i class="fa fa-file-alt" />
                            <span class="nav-text"> Forms</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/weekly-functional-tests/"
                            exact
                        >
                            <i class="fa fa-clipboard-check" />
                            <span class="nav-text"> Weekly Functional Tests</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/task-manager/"
                            exact
                        >
                            <i class="fa fa-clipboard-check" />
                            <span class="nav-text"> Task Manager</span>
                        </router-link>
                    </li>
                </ul>
                <span class="nav-title">Servicing</span>
                <ul>
                    <li>
                        <router-link
                            to="/office/service-products"
                            exact
                        >
                            <i class="fa fa-clipboard" />
                            <span class="nav-text"> Service Products</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/postcode-fees"
                            exact
                        >
                            <i class="fa fa-map" />
                            <span class="nav-text"> Postcodes</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/maintenance-planner"
                            exact
                        >
                            <i class="fa fa-calendar" />
                            <span class="nav-text"> Maintenance Planner</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/maintenance-kpi"
                            exact
                        >
                            <i class="fa fa-table" />
                            <span class="nav-text"> Maintenance KPI</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/products"
                            exact
                        >
                            <i class="fa fas fa-box" />
                            <span class="nav-text"> Products</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/fire-extinguishers"
                            exact
                        >
                            <i class="fa fas fa-fire-extinguisher" />
                            <span class="nav-text"> Fire Extinguishers</span>
                        </router-link>
                    </li>
                </ul>
                <span
                    class="nav-title"
                    v-if="user && user.admin_access"
                >Admin</span>
                <ul v-if="user && user.admin_access">
                    <li>
                        <router-link
                            to="/office/overtime/"
                            exact
                        >
                            <i class="fa fa-clock" />
                            <span class="nav-text">  Overtime
                                <span
                                    class="badge badge-pill badge-warning"
                                    v-if="unverified_overtime_count > 0"
                                >{{ unverifiedOvertimeBadgeLabel }}</span>
                            </span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/holiday-requests/"
                            exact
                        >
                            <i class="fa fa-umbrella-beach" />
                            <span class="nav-text">  Holiday Requests
                                <span
                                    class="badge badge-pill badge-warning"
                                    v-if="pending_holiday_requests_count > 0"
                                >{{ pendingHolidayRequestsBadgeLabel }}</span>
                            </span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/expenses"
                            exact
                        >
                            <i class="fa fas fa-receipt" />
                            <span class="nav-text">  Expenses</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/admin/settings/"
                            exact
                        >
                            <i class="fa fa-cog" />
                            <span class="nav-text">  System Settings</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/admin/users"
                            exact
                        >
                            <i class="fa fa-users" />
                            <span class="nav-text">  Users</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/admin/vehicles"
                            exact
                        >
                            <i class="fa fa-car" />
                            <span class="nav-text">  Vehicles</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/admin/service-reminder-types"
                            exact
                        >
                            <i class="fa fa-list" />
                            <span class="nav-text">  Service Reminder Types</span>
                        </router-link>
                    </li>
                </ul>
                <span class="nav-title">Settings</span>
                <ul>
                    <li>
                        <router-link
                            to="/office/calendar"
                            exact
                        >
                            <i class="fa fa-calendar" />
                            <span class="nav-text">  Calendar</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/cpc-forms"
                            exact
                        >
                            <i class="fa fa-star" />
                            <span class="nav-text">  CPD Forms</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/office/account"
                            exact
                        >
                            <i class="fa fa-user" />
                            <span class="nav-text">  My Account</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="'/engineer'"
                            v-if="user && user.engineer_access"
                        >
                            <i class="fa fa-wrench" />
                            <span class="nav-text"> Engineer Mode</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="'/office/email-templates'">
                            <i class="fa fa-at" />
                            <span class="nav-text"> Email Templates</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/logout"
                            exact
                        >
                            <i class="fa fa-sign-out-alt" />
                            <span class="nav-text"> Logout</span>
                        </router-link>
                    </li>
                    <li>
                        <a
                            href="#"
                            @click.prevent="toggleSidebar"
                            v-if="!sidebarHidden"
                        >
                            <i class="fa fa-chevron-circle-left" />
                            <span class="nav-text"> Hide</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="#"
                            @click.prevent="toggleSidebar"
                            v-if="sidebarHidden"
                        >
                            <i class="fa fa-chevron-circle-right" />
                            <span class="nav-text"> Show</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </aside>

        <main
            class="main"
            :class="{'sidebar-hidden' : sidebarHidden}"
        >
            <header
                class="header"
                v-if="showHeader"
            >
                <ol class="breadcrumb">
                    <li
                        v-for="(route, index) in breadcrumbRoutes"
                        class="breadcrumb-item"
                        :key="index"
                        :class="{'active' : route.name === $router.currentRoute.name}"
                        v-show="route.name"
                    >
                        <router-link
                            :to="route.path"
                            v-if="route.name !== $router.currentRoute.name"
                        >
                            {{ route.name }}
                        </router-link>
                        <span v-if="route.name === $router.currentRoute.name">{{ route.meta.title }}</span>
                    </li>
                </ol>
                <div class="header-right">
                    <button
                        v-if="updateAvailable"
                        class="btn btn-info"
                        @click="refreshToUpdate"
                    >
                        <i class="fa fa-redo-alt" /> Refresh to Update
                    </button>
                    <span
                        class="online"
                        v-if="online"
                    >Online</span>
                    <span
                        class="offline"
                        v-if="!online"
                    >Offline</span>
                    <notifications-overview />
                </div>
            </header>
            <router-view />
            <error-message />
            <info-message />
        </main>

        <comments-modal v-if="show_modal" />
    </div>
</template>

<script>
import StatsService from "../../services/StatsService";
import AuthService from "../../services/AuthService";
import CookieService from "../../services/CookieService";
import ConnectionComponent from "../ConnectionComponent.vue";
import NotificationsOverview from '../NotificationsOverviewComponent';
import { mapState } from 'vuex';

export default {
    components: {
        'connection': ConnectionComponent,
        NotificationsOverview,
    },
    data: function () {
        return {
            statsService: StatsService,
            authService: AuthService,
            customers_count: 0,
            jobs_count: 0,
            unverified_overtime_count: 0,
            pending_holiday_requests_count: 0,
            user: null,
            statsRefresh: null,
            sidebarHidden: false,
            online: true,
            updateAvailable: false,
        };
    },

    computed: {
        ...mapState('comments', ['show_modal', 'comments']),
        showHeader() {
            if (this.$route.meta.hide_header) {
                return false;
            }

            return true;
        },

        breadcrumbRoutes () {
            return this.$route.matched.filter(route => route.name);
        },
        unverifiedOvertimeBadgeLabel () {
            if (this.unverified_overtime_count > 99) {
                return '+99';
            }

            return this.unverified_overtime_count;
        },
        pendingHolidayRequestsBadgeLabel () {
            if (this.pending_holiday_requests_count > 99) {
                return '+99';
            }

            return this.pending_holiday_requests_count;
        },
    },

    mounted: function () {
        this.refreshStats();
        this.authService.getUser().then(user => {
            this.user = user;
        });
        this.sidebarHidden = JSON.parse(CookieService.get('office_sidebar_hidden'));
        this.listenToOvertimeStatsEvents();
        this.listenToHolidayRequestEvents();

        window.setInterval(() => {
            window.axios.get('/api/version').then(res => {
                if (res.data.version !== window.env.APP_VERSION) {
                    this.updateAvailable = true;
                } else {
                    this.updateAvailable = false;
                }
            })
        }, 5000 * 60);
    },

    beforeDestroy: function () {
        if (window.Echo) {
            window.Echo.leave('overtime-logs');
            window.Echo.leave('calendar-events');
        }
    },

    methods: {
        refreshStats: function () {
            this.statsService.stats().then(
                xhr => {
                    this.customers_count = xhr.data.customers_count;
                    this.jobs_count = xhr.data.jobs_count;
                    this.unverified_overtime_count = xhr.data.unverified_overtime_count || 0;
                    this.pending_holiday_requests_count = xhr.data.pending_holiday_requests_count || 0;
                }
            );
        },

        listenToOvertimeStatsEvents: function () {
            if (!window.Echo) {
                return;
            }
            const channel = window.Echo.private('overtime-logs');
            channel.listen('OvertimeLogUpdated', event => {
                this.refreshStats();
                this.$root.$emit('OvertimeLogUpdated', event);
            });
            channel.listen('OvertimeLogDeleted', event => {
                this.refreshStats();
                this.$root.$emit('OvertimeLogDeleted', event);
            });
        },

        listenToHolidayRequestEvents: function () {
            if (!window.Echo) {
                return;
            }
            const channel = window.Echo.private('calendar-events');
            channel.listen('CalendarEventUpdated', event => {
                this.refreshStats();
                this.$root.$emit('CalendarEventUpdated', event);
            });
            channel.listen('CalendarEventDeleted', event => {
                this.refreshStats();
                this.$root.$emit('CalendarEventDeleted', event);
            });
        },

        toggleSidebar: function () {
            this.sidebarHidden = !this.sidebarHidden;
            CookieService.set('office_sidebar_hidden', this.sidebarHidden);
        },
        connectionChanged: function (online) {
            this.online = online;
        },

        refreshToUpdate () {
            window.location.reload();
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/OfficeComponent.vue